import { z as zod } from 'zod';
import { DetailSchema, RelatedInfoSchema, ShowroomSchema } from "@/app/features/shared/types/schema";

export const SiteEducationSchema = zod.object({
    title: zod.string().min(1, 'Title is required'),
    subtitle: zod.string().nullish(),
    details: zod.array(DetailSchema),
    relatedInfos: zod.array(RelatedInfoSchema),
    showroom: ShowroomSchema.nullish(),
});